/** The task pocket: header, rows, details, title and description, pickers. */
export default {
  task: "Task",
  openConversation: "Open conversation",
  more: "More",
  stopAgent: "Stop the agent",
  resumeAgent: "Resume the agent",
  openParentConversation: "Open parent conversation",
  showDeliverables: "Show deliverables",
  showSourceNote: "Show source note",
  moreDetails: "More details",
  deleteTask: "Delete task",
  workerActionFailed: "Task conversation action failed",
  deliverablesFailed: "Could not show task deliverables.",
  deleteFailed: "Could not delete this task.",
  questionFailed: "Could not open question",
  assigneeFailed: "Could not update assignee",
  status: "Status",
  assignee: "Assignee",
  priority: "Priority",
  due: "Due",
  blockedBy: "Blocked by",
  parent: "Parent",
  subtask: "Subtask",
  pullRequest: "Pull request",
  open: "Open",
  nobody: "Nobody",
  subAgent: "Sub-agent",
  me: "Me",
  source: "Source",
  blocks: "Blocks",
  title: "Title",
  description: "Description",
  addDescription: "Add a description",
  showLess: "Show less",
  showMore: "Show more",
  markComplete: "Mark complete",
  markIncomplete: "Mark incomplete",
  assignAgent: "Assign agent",
  assignToAgent: "Assign to agent",
  moveToTodo: "Move to Todo",
  moveToBacklog: "Move to Backlog",
  start: "Start",
  block: "Block",
  review: "Review",
  markDone: "Done",
  cancelTask: "Cancel",
  approve: "Approve",
  rework: "Rework",
  reopen: "Reopen",
  restart: "Restart",
  unblock: "Unblock",
  sourceNote: "Note",
  sourceChat: "Chat",
  sourceHeartbeat: "Heartbeat",
  sourceSchedule: "Schedule",
  sourceMention: "Mention",
  sourceAssignment: "Assignment",
  sourceDelegation: "Delegation",
  sourceEvent: "Event",
  sourceTemplate: "Project template",
} as const;
